/**
 * @fileoverview Shared visual tokens for generator growth funnel surfaces.
 * @description Solid fills only — no blur orbs or multi-stop gradients that
 * band in dark mode and headless captures.
 */

/** Outer card shell shared by page upsell and export hint. */
export const GENERATOR_GROWTH_CARD_CLASS =
  'rounded-2xl border border-indigo-100 bg-indigo-50/90 p-5 shadow-sm dark:border-indigo-500/30 dark:bg-indigo-950/50'

/** Compact card for the tool sidebar export hint. */
export const GENERATOR_GROWTH_COMPACT_CARD_CLASS =
  'rounded-xl border border-indigo-100 bg-indigo-50/90 p-4 shadow-sm dark:border-indigo-500/30 dark:bg-indigo-950/50'

/** Primary CTA — explicit indigo fill so it reads as a button in dark mode. */
export const GENERATOR_GROWTH_CTA_CLASS =
  'inline-flex w-full items-center justify-center gap-2 rounded-lg bg-indigo-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 dark:bg-indigo-500 dark:hover:bg-indigo-400 dark:focus-visible:outline-indigo-400'

/** Icon tile behind growth funnel glyphs. */
export const GENERATOR_GROWTH_ICON_TILE_CLASS =
  'flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-indigo-600 text-white dark:bg-indigo-500'
